// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail_3Ajcy","listWrap":"detail_listWrap_3iP7n"};